/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/paging/paging',['require','jquery','underscore','backbone','marionette','modules/paging/book'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Marionette = require('marionette');
  //var Library = require('modules/paging/library');
  //var PagingObject = require('modules/paging/paging-object');
  var Book = require('modules/paging/book');

  /*****************************************************************************************************************///}

  var Paging = Marionette.Module.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    data: { },
    root: null,
    position: 0,
    settings: { },
    currentPage: null,
    pages: new Backbone.Collection(),
    finishedModule: null,
    courseComplete: false,
    completionDate: null,
    playingGame: false,
    courseID: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    onStart: function(options)
    {
      //console.log('Paging::start');

      this.settings = _.clone(options.settings);

      var self = this;

      this.app.radio.on('bookmark.received', function(patch, data, localData)
      {
        var datachunk;
        var localDatachunk;
        var patchDatachunk;

        try
        {
          datachunk = JSON.parse(data.datachunk);
        }
        catch (err)
        {
          datachunk = { };
        }

        try
        {
          localDatachunk = JSON.parse(localData.datachunk);
        }
        catch (err)
        {
          localDatachunk = { };
        }

        try
        {
          patchDatachunk = JSON.parse(patch.datachunk);
        }
        catch (err)
        {
          patchDatachunk = { };
        }

        //console.log('deserialize patch');
        self.deserialize(patchDatachunk);
        //console.log('deserialize api');
        self.deserialize(datachunk);
        //console.log('deserialize local');
        self.deserialize(localDatachunk);

        self.root.setRequirements();
        self.root.checkLocks();

        self.pages.reset(self.root.getPages());

        if (data.status !== 2 && self.courseComplete)
        {
          self.app.module('Bookmark').setComplete();
        }

        if (self.settings.preload)
        {
          // wait for all pages to load
          var pageLoaded = _.after(self.pages.length, function()
          {
            _.delay(_.bind(self.ready, self), 1000);
          });
          self.pages.each(function(page)
          {
            page.on('page.ready', pageLoaded);
          });

          // load all
          self.pages.invoke('load');
        }
        else
        {
          _.delay(_.bind(self.ready, self), 1000);
        }
        //console.log('set.bookma');
        self.app.radio.trigger('set.bookmark');
        //self.app.module('Bookmark').save();
      });

      this.load(options.settings.paging, options.settings.pagingMap, function()
      {
        self.app.module('Bookmark').fetch();
      });

      // update paging
      this.app.radio.on('page.active', function(page)
      {
        self.currentPage = page;
      });

      this.app.radio.on('paging:checklocks', this.checkLocks, this);
      this.app.radio.on('status:change', this.onStatusChange, this);
      //this.app.radio.on('unlock.minigame.achievement', this.onUnlockMinigameByAchievement, this);
    },

    ready: function()
    {
      this.app.radio.trigger('paging.loaded', this);
    },

    load: function(pagingPath, mapPath, callback) // load paging array and build local copy
    {
      ////console.log('Paging::build');

      pagingPath = pagingPath || 'config/paging.json';
      mapPath = mapPath || 'config/paging-map.json';
      callback = callback || _.noop;

      var customMap = _.get(this.app.query, 'map', false);

      if (customMap)
      {
        var mapPathArr = mapPath.split('.');
        mapPath = mapPathArr[mapPathArr.length - 2] + '-' + customMap + '.' + mapPathArr[mapPathArr.length - 1];
      }

      //console.log(this.app.query,  mapPath);

      //require([], $.proxy(this.build, this, callback));
      require(['json!' + mapPath, 'json!' + pagingPath], $.proxy(this.build, this, callback));
    },

    build: function(callback, map, data)
    {
      //console.log('BUILD');

      this.map = _.clone(map);
      this.data = _.clone(data);

      this.app.config.mapSettings = this.map.settings || {};
      this.app.config.courseInfo = this.map.courseInfo;
      this.courseID = this.map.courseInfo.courseID;
      //var self = this;

      // convert content array into id based key object
      var __mapData = _.zipObject(_.pluck(this.map.content, 'id'), _.pluck(this.map.content, 'content'));
      /*var __achievementData = this.map.achievements;

      _.each(__achievementData, function(__aObj, __code) {
        this.app.module('Achievement').addAchievement(__code, __aObj);
      }, this);*/

      var __sectionContent;
      var __filteredContent = [];
      var __mapContent;

      // check each paging array item
      _.each(this.data.content, function(__pagingSection) {
        __sectionContent = __pagingSection.content;

        if (__pagingSection.id === 'splash') // splash found, should be modified
          __mapContent = __mapData.splash;
        else if (__pagingSection.id === 'modules') // modules found, should be modified
          __mapContent = __mapData.modules;
        else // no match, items should not be modified
          return;
        /*else if (__pagingSection.id === 'minigames') // modules found, should be modified
          __mapContent = __mapData.minigames;
        */
        // create a modified array of filtered content based on the map data
        __filteredContent = _.filter(__sectionContent, function(pagingData) {
          var __match = false;
          // cross reference current paging array object with map data
          _.each(__mapContent, function(mapData) {
            if (mapData.id === pagingData.id) { // id found in paging map
              pagingData.requirements = (mapData['module_prereqs']) ? mapData['module_prereqs'].split(',') : [];
              pagingData.required = (mapData['required']) ? mapData['required'] : false;
              //pagingData.onCompleteOverlayPageName = (mapData['on_complete_overlay']) ? mapData['on_complete_overlay'] : null;
              pagingData.section = __pagingSection.id;
              pagingData.unlock = mapData['unlock'] || pagingData.unlock;
              ////console.log('match', mapData, pagingData);
              __match = true;
              return; // stop searching
            }
          });
          return __match;
        });

        __pagingSection.content = __filteredContent;
        //console.warn('pagingsection', __pagingSection);
      });

      this.root = new Book(this.data, __mapData);
      //console.log('root', this.root);
      this.root.set('type', 'root');
      this.root.on('change', this.onRootChange, this);

      callback(this);
    },

    onStatusChange: function(e)
    {
      ////console.log('Paging::onStatusChange');

      this.app.radio.trigger('set.bookmark');

      this.root.checkLocks();
    },

    checkLocks: function(pagingObject)
    {
      if (!pagingObject)
      {
        console.warn('PagingObject not found: ' + pagingObject);
        return;
      }

      ////console.log('Paging::checkLocks', pagingObject);

      var self = this;
      var allComplete = _.every(pagingObject.get('requirements'), function(id, index)
      {
        var $reqMod = self.find(id);
        if (!$reqMod)
        {
          //console.warn('$reqModuirement not found: ' + id);
          return true;
        }

        ////console.log($reqMod.get('complete'));
        /*
        REMOVED 5/19 per ARC
        if ($reqMod.get('level') === 3)
          return $reqMod.isComplete();
        else
          return $reqMod.seen();*/
        return $reqMod.seen();
      });

      ////console.log(allComplete, pagingObject.get('requirements').length);
      //console.log('check locks', this.settings.forcedOrder, allComplete);
      if (((allComplete || pagingObject.get('requirements').length === 0) && pagingObject.get('unlock') === undefined) || !this.settings.forcedOrder)
        pagingObject.unlock();
      //else
        //console.log('check locks', pagingObject, pagingObject.get('unlock'));
      //else
      //  pagingObject.lock();
    },

    find: function(id)
    {
      return this.root.find(id);
    },

    next: function(object)
    {
      object = object || this.currentPage; // default to current page if none provided

      // if current object's book has a next page, return that
      // otherwise, check object's book's parent for next object

      var nextObj;

      if (object.collection && object.collection.parent)
      {
        nextObj = object.collection.parent.next();

        if (!nextObj)
        {
          if (this.app.config.settings.skipMenu)
          {
            nextObj = this.next(object.collection.parent);
          }
          else if (!object.collection.parent.get('filter'))
          {
            //console.log('no filter', object, object.get('filter'));
            object.collection.parent.set('position', 0);
            nextObj = this.findMenu(object);
          }
          else
          {
            nextObj = this.finishModule(object.collection.parent);
          }
        }
      }

      return nextObj;
    },

    prev: function(object)
    {
      object = object || this.currentPage; // default to current page if none provided

      // if current object's book has a previous page, return that
      // otherwise, check object's book's parent for previous object

      var prevObj;

      if (object.collection && object.collection.parent)
      {
        prevObj = object.collection.parent.prev();

        if (!prevObj)
        {
          if (this.app.config.settings.skipMenu)
          {
            prevObj = this.prev(object.collection.parent);
          }
          else
          {
            object.collection.parent.set('position', 0);
            prevObj = this.findMenu(object);
          }
        }
      }

      return prevObj;
    },

    findMenu: function(obj)
    {
      var menu = obj.collection.findWhere({ menu: true });
      if (menu)
        return menu;

      // menu not found, keep looking or abandon search if at root
      return (obj.collection.parent) ? this.findMenu(obj.collection.parent) : null;
    },

    finishModule: function($module)
    {
      this.finishedModule = $module;
      $module.gradeModule();
      if ($module.isComplete())
      {
        //console.log('check em');
        //this.checkModuleAchievements($module);
      }
      else
      {
        //console.log('not complete');
      }
      if ($module.seen())
      {
        //this.checkMinigameUnlocks($module);
      }

      $module.set('position', 0);
      //this.checkAssessmentRequired();
      this.onStatusChange();
      return this.findMenu($module);
    },

    /*checkModuleAchievements: function($module)
    {
      //console.log('check module achievements');
      var $completeCount = 0;
      var $silverCount = 0;
      var $goldCount = 0;

      var modules = this.root.find('modules').content.models;
      _.each(modules, function(module) {
        ////console.log('every mod', module);
        if (module.isComplete() && module.get('level') !== 0)
        {
          switch (module.medal())
          {
            /* jshint ignore:start * /
            case 'medal_gold':
              $goldCount++;
            case 'medal_silver':
              $silverCount++;
            case 'medal_bronze':
              $completeCount++;
              break;
            /* jshint ignore:end * /
          }
        }
      }, this);

      // LM: Added achievements by module ID
      this.app.module('Achievement').setAchievementCompleteByCode('complete_module_' + $module.id);
      //console.log('complete count: ', $completeCount, $silverCount, $goldCount);
      this.app.module('Achievement').setAchievementCompleteByCode('complete_module_' + $completeCount);
      this.app.module('Achievement').setAchievementCompleteByCode('silver_module_' + $silverCount);
      this.app.module('Achievement').setAchievementCompleteByCode('gold_module_' + $goldCount);
    },

    checkMinigameUnlocks: function(module)
    {
      var minigamesCol = this.root.find('minigames');//.content.models;
      //console.log('check minigame unlocks', 'complete_module_' + module.get('id'), module);
      var self = this;
      _.each(minigamesCol.content.models, function(minigame) {
        //console.log('minigame', minigame);
        if (minigame.get('unlock') === 'complete_module_' + module.get('id'))
        {
          var minigamepage = minigamesCol.find(minigame.get('id'));
          minigamepage.unlock();
          self.app.radio.trigger('minigame.unlock.show', minigamepage);
          //console.log('unlock minigame', minigamepage);
        }
      });
    },

    onUnlockMinigameByAchievement: function($code, $display)
    {
      //console.log('unlock minigame achievement', $code, $display);
      var minigamesCol = this.root.find('minigames');//.content.models;
      var self = this;
      _.each(minigamesCol.content.models, function(minigame) {
        //console.log('minigame', minigame);
        if (minigame.get('unlock') === $code)
        {
          var minigamepage = minigamesCol.find(minigame.get('id'));
          minigamepage.unlock();

          if ($display)
            self.app.radio.trigger('minigame.unlock.show', minigamepage);

          //console.log('unlock minigame', minigamepage, minigamepage.unlock);
        }
      });
    },*/
    firstModule: function()
    {
      return this.root.find('modules').content.models[0];
    },

    getModules: function()
    {
      var moduleModels = this.root.find('modules').content.models;
      return _.zipObject(_.pluck(moduleModels, 'id'), moduleModels);
    },

    completionStatus: function()
    {
      var __totalMods = this.root.find('modules').content.models;
      var __modsComplete = 0;
      _.each(__totalMods, function(mod) {
        if (mod.get('complete'))
          __modsComplete++;
      });
      var __perc = Math.round((__modsComplete / __totalMods.length) * 100);

      var __statusObj = {
        total: this.root.find('modules').content.models.length,
        complete: __modsComplete,
        perc: __perc
      };
      return __statusObj;
    },

    allModulesComplete: function()
    {
      var $faComplete = this.faLvl3Complete() && (this.faAssessmentComplete() || this.faModulesSeen());
      var $cprComplete = this.cprLvl3Complete() && (this.cprAssessmentComplete() || this.cprModulesSeen());

      return $faComplete && $cprComplete;
      /*var modules = this.root.find('modules').content.models;
      return _.every(modules, function(module) {
        if (!module.get('required') || module.get('level') !== 3)
          return true;
        //console.log('every mod', module.get('required'), module.get('level'), module.isComplete(), module.get('id'));

        return module.isComplete();
      });*/
    },

    faModulesSeen: function()
    {
      var modules = this.getAllFAMods(['fa-1', 'fa-2']);// this.root.find('modules').content.models;
      return _.every(modules, function(module) {
        console.log('every', module.id, module.seen());
        return module.seen();
      });

      /*var $arr:Array = Module.getAllFAMods();
      var $module:Module;
      for each ($module in $arr)
      {
        if ($module.level !== 3) // non lvl 3
        {
          if (!$module.seen)
          {
            return false;
          }
        }
      }
      return true;*/
    },
    faAssessmentComplete: function()
    {
      var modules = this.getAllFAMods(['fa-3']);// this.root.find('modules').content.models;
      var hasAssessment = false;
      var completed = _.every(modules, function(module) {
        if (module.id.indexOf('assessment') !== -1)
        {
          hasAssessment = true;
          return module.get('complete');
        }
        return true;
      });

      if (modules.length > 0 && hasAssessment)
        return completed;
      return false;
    },
    faLvl3Complete: function()
    {
      var modules = this.getAllFAMods(['fa-3']);// this.root.find('modules').content.models;
      var completed = _.every(modules, function(module) {
        //console.log('fa complete', module);
        if (module.id.indexOf('assessment') === -1)
          return module.get('complete');
        return true;
      });

      if (modules.length > 0)
        return completed;
      return true;

      /*var $arr:Array = Module.getAllFAMods();
      var $module:Module;
      for each ($module in $arr)
      {
        if ($module.level == 3 && $module.name.indexOf('assessment') == -1) // lvl 3
        {
          if (!$module.isComplete)
          {
            return false;
          }
        }
      }
      return true;*/
    },
    cprModulesSeen: function()
    {
      var modules = this.getAllCPRMods(['cpr-1', 'cpr-2']);// this.root.find('modules').content.models;
      return _.every(modules, function(module) {
        return module.seen();
      });

      /*var $arr:Array = Module.getAllCPRMods();
      var $module:Module;
      for each ($module in $arr)
      {
        if ($module.level !== 3) // non lvl 3
        {
          if (!$module.seen)
          {
            return false;
          }
        }
      }
      return true;*/
    },
    cprAssessmentComplete: function()
    {
      var modules = this.getAllCPRMods(['cpr-3']);// this.root.find('modules').content.models;
      var hasAssessment = false;
      var completed = _.every(modules, function(module) {
        if (module.id.indexOf('assessment') !== -1)
        {
          hasAssessment = true;
          return module.get('complete');
        }
        return true;
      });

      if (modules.length > 0 && hasAssessment)
        return completed;
      return false;

      /*var $arr:Array = Module.getAllCPRMods();
      var $module:Module;
      for each ($module in $arr)
      {
        if ($module.name.indexOf('assessment') != -1) // non lvl 3
        {
          if ($module.isComplete)
          {
            return true;
          }
        }
      }
      return false;*/
    },
    cprLvl3Complete: function()
    {
      var modules = this.getAllCPRMods(['cpr-3']);// this.root.find('modules').content.models;
      var completed = _.every(modules, function(module) {
        if (module.id.indexOf('assessment') === -1)
          return module.get('complete');
        return true;
      });

      if (modules.length > 0)
        return completed;
      return true;

      /*var $arr:Array = Module.getAllCPRMods();
      var $module:Module;
      for each ($module in $arr)
      {
        if ($module.level == 3 && $module.name.indexOf('assessment') == -1) // non lvl 3
        {
          if (!$module.isComplete)
          {
            return false;
          }
        }
      }
      return true;*/
    },

    setCourseComplete: function()
    {
      //this.app.module('Achievement').setAchievementCompleteByCode('event_course_complete');
      this.courseComplete = true;
      this.setCompleteDate();

      this.app.module('Bookmark').setComplete();
      this.app.module('Bookmark').save({ score: Math.floor(this.getRequiredModulesPerc() * 100) });
    },

    setCompleteDate: function()
    {
      /* jscs: disable */
      if (!this.completionDate) // check that it's not already set
      {
        var d = new Date();
        var date = d.toDateString() + ', ' + d.toLocaleTimeString();//queryobj.date;

        try {
          if (window.API && window.API.CustomData && window.API.CustomData.completed_on)
            date = window.API.CustomData.completed_on;
        }
        catch (err) {
          console.log('error checking db', err);
        }

        this.completionDate = date;
      }
      /* jscs: enable */
    },

    /*checkAssessmentRequired: function()
    {
      console.log('check assessment required');
      var modules = this.root.find('modules').content.models;
      var self = this;
      _.each(modules, function(module) {
        if (module.id.indexOf('assessment') !== -1)
        {
          var $modsSeen = false;
          if (module.get('filter') === 'cpr-3')
          {
            $modsSeen = self.cprModulesSeen();
          }
          else if (module.get('filter') === 'fa-3')
          {
            $modsSeen = self.faModulesSeen();
          }
          console.log('mod', module.id, module.get('filter'), module.get('complete'), $modsSeen);
          if (!module.get('complete') && $modsSeen)
            module.set('required', false);
        }
      });
    },*/

    getModulesByFilter: function(filter)
    {
      var moduleModels = this.root.find('modules').content.models;
      var filteredMods = _.where(moduleModels, {'attributes': {'filter': filter}});
      filteredMods.concat(_.where(moduleModels, {'attributes': {'filter': null}}));
      return _.zipObject(_.pluck(filteredMods, 'id'), filteredMods);
    },

    getPagesBySection: function(section)
    {
      //var moduleModels = this.root.find('modules');
    },

    getRequiredModulesPerc: function()
    {
      var $perc = 0;
      var $total = 0;

      var modules = this.root.find('modules').content.models;
      _.each(modules, function(module) {
        if (module.get('required') && module.get('level') === 3)
        {
          $total++;
          $perc += module.get('earnedPerc') || 0;
        }
      }, this);

      $perc = $perc / $total;
      return $perc;
    },

    checkAllModulesSeenByFilter: function(filter)
    {
      var modules = this.getModulesByFilter(filter);
      return _.every(modules, function(module) {
        ////console.log('check', module, module.seen());
        if (!module.get('required'))
          return true;

        return module.seen();
      });
    },

    checkAllModulesCompleteByFilter: function(filter)
    {
      var modules = this.getModulesByFilter(filter);
      return _.every(modules, function(module) {
        return module.get('complete');
      });
    },

    checkAllModulesCompleteByLevel: function($level)
    {
      var modules = this.root.find('modules').content.models;
      var levelComplete = true;
      _.each(modules, function(module) {
        //console.warn('check by level', $level, module.get('level'), module.get('complete'));
        if (module.get('level') === $level && !module.get('complete'))
        {
          levelComplete = false;
          return false;
        }
      });

      return levelComplete;
    },

    getAllCPRMods: function($filterArr)
    {
      var $arr = [];
      var modules = this.root.find('modules').content.models;

      _.each(modules, function(module) {
        if ($filterArr.indexOf(module.get('filter')) !== -1)
        {
          $arr.push(module);
        }
      });

      return $arr;
    },

    getAllFAMods: function($filterArr)
    {
      var $arr = [];
      var modules = this.root.find('modules').content.models;

      _.each(modules, function(module) {
        if ($filterArr.indexOf(module.get('filter')) !== -1)
        {
          $arr.push(module);
        }
      });

      return $arr;
    },

    checkNewCPRMods: function($filterArr)
    {
      var modules = this.root.find('modules').content.models;
      var $hasNew = false;

      _.each(modules, function(module) {
        if ($filterArr.indexOf(module.get('filter')) !== -1 && !module.get('complete') && !module.get('locked'))
        {
          $hasNew = true;
        }
      });

      return $hasNew;
    },

    checkNewFAMods: function($filterArr)
    {
      var modules = this.root.find('modules').content.models;
      var $hasNew = false;

      _.each(modules, function(module) {
        if ($filterArr.indexOf(module.get('filter')) !== -1 && !module.get('complete') && !module.get('locked'))
        {
          $hasNew = true;
        }
      });

      return $hasNew;
    },

    getAvailableModsByFilter: function($filter)
    {
      var $arr = [];
      var $filterMods = this.getModulesByFilter($filter);

      _.each($filterMods, function($module) {
        if (!$module.get('locked'))
        {
          $arr.push($module);
        }
      }, this);

      return $arr;
    },

    getNewModsByFilter: function($filter)
    {
      var $arr = [];
      var $filterMods = this.getModulesByFilter($filter);

      _.each($filterMods, function($module) {
        if (!$module.get('complete') && !$module.get('locked'))
        {
          $arr.push($module);
        }
      }, this);

      return $arr;
    },

    /*checkCompleteOverlay: function()
    {
      ////console.log('check complete overlay');
      var modules = this.root.find('modules').content.models;
      var $page = null;

      _.each(modules, function($module) {
        ////console.log('check complete overlay: ', $module);
        if ($module.seen() && $module.get('onCompleteOverlayPageName') != null)
        {
          var $oPage = this.root.find($module.get('onCompleteOverlayPageName'));
          ////console.log('complete page found', $oPage);
          if ($oPage && !$oPage.get('complete'))
          {
            $page = $oPage;
            return false;
          }
        }
      }, this);

      return $page;
    },*/

    serialize: function(toJSON)
    {
      var data = { };
      data.status = { };
      data.c = this.courseComplete ? 1 : 0;
      data.cd = this.completionDate || 0;
      //data.a = this.app.module('Achievement').serialize();
      console.warn('serializing paging', this.completionDate);

      this.root.content.each(function(obj) {
        data.status[obj.id] = obj.serialize();
      });

      return (toJSON) ? JSON.stringify(data) : data;
    },

    deserialize: function(data)
    {
      ////console.log('Paging::deserialize');
      ////console.log(data);
      if (!data)
        return;
      this.courseComplete = data.c === 1 ? true : false;

      if (data.cd !== undefined && !this.completionDate)
        this.completionDate = data.cd === 0 ? null : data.cd;

      var obj;

      for (var id in data.status)
      {
        obj = this.root.content.get(id);

        if (obj)
          obj.deserialize(data.status[id]);
      }
      //this.app.module('Achievement').deserialize(data.a);
      //this.checkAssessmentRequired();
    }

  /*****************************************************************************************************************///}

  });

  return Paging;

});

